import { render, staticRenderFns } from "./LoginBox.vue?vue&type=template&id=ee470adc&"
import script from "./LoginBox.vue?vue&type=script&lang=ts&"
export * from "./LoginBox.vue?vue&type=script&lang=ts&"
import style0 from "./LoginBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports